import { render } from "./customInstrument.vue?vue&type=template&id=32fe6e62&scoped=true"
import script from "./customInstrument.vue?vue&type=script&lang=js"
export * from "./customInstrument.vue?vue&type=script&lang=js"

import "./customInstrument.vue?vue&type=style&index=0&id=32fe6e62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fe6e62"]])

export default __exports__